import clientInfo from 'common/lib/clientInfo';
import { useCallback } from 'react';
import { trackProductAnalytics } from 'common/services/product_analytics';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { CopyMagicMetaType } from 'common/components/CopyMagic/CopyMagic.types';

const useTrackFeedbackSentiment = () => {
  const { feedbackSentiment } = useUiResourceContext();
  const feedbackToInteger = feedbackSentiment.positive === true ? 1 : 2;

  const trackCallback = useCallback(
    ({ contentId, metaData }: { contentId: string; metaData?: CopyMagicMetaType }) => {
      if (feedbackSentiment.positive === null) return;

      trackProductAnalytics('Course Outline Generator Feedback', {
        'Site ID': clientInfo.get('site_id'),
        'Feedback Sentiment Enum': feedbackToInteger,
        'Content ID': contentId,
        'Course Outline Model Used': metaData?.modelName,
      });
    },
    [feedbackSentiment.positive, feedbackToInteger],
  );

  return trackCallback;
};

export default useTrackFeedbackSentiment;
